import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { SpecialityHasCourseItem, SpecialityHasCourse } from '../models';

export class SpecialityHasCourseApi extends ApiModule {
  protected endpoint = '/speciality-has-course';

  public async pageSpecialityHasCourses(params: any) {
    return this.api.post<PaginatedResponseData<SpecialityHasCourseItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadSpecialityHasCourseDetails(id: number) {
    return this.api.get<SpecialityHasCourse>(`${this.endpoint}?id=${id}`);
  }

  public saveSpecialityHasCourse(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteSpecialityHasCourse(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
